import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// styles
const ElipsesSingleLineStyled = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

// component
export const ElipsesSingleLine = ({ className, string }) => {
    return (
        <ElipsesSingleLineStyled className={className}>
            {string}
        </ElipsesSingleLineStyled>
    );
};

export default ElipsesSingleLine;

// prop-types
ElipsesSingleLine.propTypes = {
    className: PropTypes.string,
    string: PropTypes.string.isRequired
};
